module.exports = "<div ui-view=\"content\" class=\"module-wrapper\"></div>\n"